<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div class="row mt-5">
          <div class="form-group">
            <div class="form-label-group ml-4">
              <input
                type="text"
                id="inputSearch"
                class="form-control"
                placeholder="ძებნა"
              />
              <label for="inputSearch">ძებნა</label>
            </div>
          </div>
          <i class="fa fa-search searchBtn ml-3 mt-1" title="ძებნა"></i>
          <i
            class="fa fa-plus-circle addNewBtn mt-1 ml-4"
            title="ორგანიზაციის დამატება"
            data-toggle="modal"
            data-target="#exampleModalLong"
            data-backdrop="static"
            data-keyboard="false"
            @click="clearData(), modalPrepare()"
          ></i>
        </div>
      </div>
    </div>
    <div
      class="modal fade bd-example-modal-lg"
      ref="addModal"
      id="exampleModalLong"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLongTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header green-color">
            <h5 class="modal-title text-white" id="exampleModalLongTitle">
              ორგანიზაციის მენიუ ჯგუფების დამატება
            </h5>
            <button
              type="button"
              class="close text-white"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <section class="container py-4">
              <div class="row">
                <div class="col-md-12">
                  <ul id="tabsJustified" class="nav nav-tabs">
                    <li class="nav-item">
                      <a
                        data-target="#legalBrandMenuGroup"
                        data-toggle="tab"
                        class="nav-link small text-uppercase modal-nav active pointer"
                        >ორგანიზაციის მენიუ ჯგუფები</a
                      >
                    </li>
                    <li class="nav-item">
                      <a
                        data-target="#legalBrands"
                        data-toggle="tab"
                        class="nav-link small text-uppercase modal-nav pointer"
                        >ლეგალ ბრენდები</a
                      >
                    </li>
                  </ul>
                  <br />
                  <div id="tabsJustifiedContent" class="tab-content">
                    <div
                      id="legalBrandMenuGroup"
                      class="tab-pane fade"
                      v-bind:class="{ active: isActive, show: isActive }"
                    >
                      <div class="row">
                        <form class="col-12 col-md-6">
                          <div class="form-group">
                            <div class="form-label-group">
                              <input
                                type="text"
                                id="nameGeAdd"
                                class="form-control"
                                placeholder="სახელი ქართულად"
                                autofocus="autofocus"
                                v-model="legalBrandMenuGroup.nameGe"
                                v-on:input="$v.legalBrandMenuGroup.$touch"
                                v-bind:class="{
                                  'error-border':
                                    $v.legalBrandMenuGroup.nameGe.$error,
                                  valid:
                                    $v.legalBrandMenuGroup.nameGe.$dirty &&
                                    !$v.legalBrandMenuGroup.nameGe.$invalid,
                                }"
                              />
                              <label for="nameGeAdd">სახელი ქართულად</label>
                            </div>
                            <div class="form-label-group mt-3">
                              <input
                                type="text"
                                id="nameEnAdd"
                                class="form-control"
                                placeholder="English Name"
                                v-model="legalBrandMenuGroup.nameEn"
                                v-on:input="$v.legalBrandMenuGroup.$touch"
                                v-bind:class="{
                                  'error-border':
                                    $v.legalBrandMenuGroup.nameEn.$error,
                                  valid:
                                    $v.legalBrandMenuGroup.nameEn.$dirty &&
                                    !$v.legalBrandMenuGroup.nameEn.$invalid,
                                }"
                              />
                              <label for="nameEnAdd">English Name</label>
                            </div>
                            <div class="form-label-group mt-3">
                              <input
                                type="text"
                                id="nameRuAdd"
                                class="form-control"
                                placeholder="имя на русском"
                                v-model="legalBrandMenuGroup.nameRu"
                                v-on:input="$v.legalBrandMenuGroup.$touch"
                                v-bind:class="{
                                  'error-border':
                                    $v.legalBrandMenuGroup.nameRu.$error,
                                  valid:
                                    $v.legalBrandMenuGroup.nameRu.$dirty &&
                                    !$v.legalBrandMenuGroup.nameRu.$invalid,
                                }"
                              />
                              <label for="nameRuAdd">имя на русском</label>
                            </div>
                            <div class="form-group form-check mt-3">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                id="showOnlyMainAdd"
                                v-model="legalBrandMenuGroup.showOnlyMain"
                              />
                              <label
                                class="form-check-label"
                                for="showOnlyMainAdd"
                                >მხოლოდ მთავარზე ჩვენება</label
                              >
                            </div>
                            <div class="form-group form-check mt-3">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                id="showOnDashboardAdd"
                                v-model="legalBrandMenuGroup.showOnDashboard"
                              />
                              <label
                                class="form-check-label"
                                for="showOnDashboardAdd"
                                >Dashboard-ზე ჩვენება</label
                              >
                            </div>
                            <div class="form-group form-check mt-3">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                id="showOnlyDashboardAdd"
                                v-model="legalBrandMenuGroup.showOnlyDashboard"
                              />
                              <label
                                class="form-check-label"
                                for="showOnlyDashboardAdd"
                                >მხოლოდ Dashboard-ზე ჩვენება</label
                              >
                            </div>
                          </div>
                        </form>
                        <form class="col-12 col-md-6">
                          <div class="form-group">
                            <div class="form-label-group">
                              <input
                                type="number"
                                id="orderPriorityAdd"
                                class="form-control"
                                placeholder="პრიორიტეტი"
                                v-model="legalBrandMenuGroup.orderPriority"
                                v-on:input="$v.legalBrandMenuGroup.$touch"
                                v-bind:class="{
                                  'error-border':
                                    $v.legalBrandMenuGroup.orderPriority.$error,
                                  valid:
                                    $v.legalBrandMenuGroup.orderPriority
                                      .$dirty &&
                                    !$v.legalBrandMenuGroup.orderPriority
                                      .$invalid,
                                }"
                              />
                              <label for="orderPriorityAdd">პრიორიტეტი</label>
                            </div>
                            <div class="form-label-group">
                              <div class="dropdown mt-3">
                                <button
                                  class="btn green-color dropdown-toggle"
                                  type="button"
                                  id="dropdownProductCategorySelect"
                                  data-toggle="dropdown"
                                  aria-haspopup="true"
                                  aria-expanded="false"
                                >
                                  {{ dropDownLegalCategory }}
                                </button>
                                <div
                                  class="dropdown-menu"
                                  aria-labelledby="dropdownProductCategorySelect"
                                  style="
                                    max-height: 400px;
                                    overflow: hidden auto;
                                  "
                                >
                                  <a
                                    class="dropdown-item pointer"
                                    v-for="categoryValue in legalCategoriesArray"
                                    :key="categoryValue.id"
                                    v-on:focus="$v.legalBrandMenuGroup.$touch"
                                    @click="
                                      dropDownCategoryClick(
                                        categoryValue.nameGe,
                                        categoryValue.id
                                      )
                                    "
                                    v-bind:class="{
                                      'error-border':
                                        $v.legalBrandMenuGroup.lbCategoryId
                                          .$error,
                                      valid:
                                        $v.legalBrandMenuGroup.lbCategoryId
                                          .$dirty &&
                                        !$v.legalBrandMenuGroup.lbCategoryId
                                          .$invalid,
                                    }"
                                    >{{ categoryValue.nameGe }}</a
                                  >
                                </div>
                              </div>
                            </div>
                            <div class="form-group form-check mt-3">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                id="showOnMainAdd"
                                v-model="legalBrandMenuGroup.showOnMain"
                              />
                              <label
                                class="form-check-label"
                                for="showOnMainAdd"
                                >მთავარზე ჩვენება</label
                              >
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                    <div id="legalBrands" class="tab-pane fade">
                      <div class="row">
                        <div class="col-5">
                          <autocomplete
                            :list="legalBrandArray"
                            class="ml-4"
                            :resetField="resetAutocomplete"
                            optionField="nameGe"
                            placeHolderValue="ლეგალ ბრენდის დასახელება"
                            @input="onAutocompleteInput"
                          >
                            <div slot="list-item" slot-scope="{ item }">
                              {{ item.nameGe }}
                              <br />
                              {{ item.descGe }}
                            </div>
                          </autocomplete>
                        </div>
                      </div>
                      <div class="row">
                        <div v-if="legalBrandMenuGroup.legalBrands.length > 0">
                          <div
                            v-for="legalBrandValue in legalBrandMenuGroup.legalBrands"
                            :key="legalBrandValue.id"
                            class="modal-card card mt-3"
                          >
                            <div class="card-body row">
                              <div class="col-11">
                                სახელი: {{ legalBrandValue.nameGe }}
                                <br />
                                აღწერა: {{ legalBrandValue.descGe }}
                              </div>
                              <div class="col-1">
                                <i
                                  class="fas fa-times deleteBtn"
                                  title="წაშლა"
                                  @click="
                                    removeLegalBrandFormList(legalBrandValue.id)
                                  "
                                ></i>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-danger" data-dismiss="modal">
              დახურვა
            </button>
            <button
              v-if="!isActiveModalPrepare"
              type="button"
              class="btn btn-success"
              :disabled="
                !$v.legalBrandMenuGroup.$dirty || $v.legalBrandMenuGroup.$error
              "
              @click="$v.legalBrandMenuGroup.$touch(), addLegalMenuGroup()"
              data-dismiss="modal"
            >
              დამახსოვრება
            </button>
            <button
              v-if="isActiveModalPrepare"
              type="button"
              class="btn btn-success"
              :disabled="
                !$v.legalBrandMenuGroup.$dirty || $v.legalBrandMenuGroup.$error
              "
              @click="$v.legalBrandMenuGroup.$touch(), editLegalMenuGroup()"
              data-dismiss="modal"
            >
              რედაქტირება
            </button>
          </div>
        </div>
      </div>
    </div>
    <div id="no-more-tables">
      <table
        class="col-md-12 table-bordered table-striped table-condensed cf mt-5"
      >
        <thead class="cf" style="border-style: none">
          <tr>
            <th class="numeric">სახელი ქართულად</th>
            <th class="numeric">English Name</th>
            <th class="numeric">имя на русском</th>
            <th class="numeric">პროდუქტი</th>
            <th class="numeric">მთავარზე ჩვენება</th>
            <th class="numeric">რედაქტირება</th>
          </tr>
        </thead>
        <tbody>
          <tr
            class="heading"
            v-for="value in legalBrandMenuGroupsArray"
            :key="value.identificationCode"
          >
            <td data-title="სახელი ქართულად" class="numeric">
              {{ value.nameGe }}
            </td>
            <td data-title="English Name" class="numeric">
              {{ value.nameEn }}
            </td>
            <td data-title="имя на русском" class="numeric">
              {{ value.nameRu }}
            </td>
            <td data-title="პროდუქტი" class="numeric">
              {{ value.orderPriority }}
            </td>
            <td data-title="მთავარზე ჩვენება" class="numeric">
              {{ value.showOnMain }}
            </td>
            <td data-title="რედაქტირება" class="numeric">
              <div>
                <i
                  class="fa fa-pencil-alt fa-fw editBtn"
                  title="რედაქტირება"
                  data-toggle="modal"
                  data-target="#exampleModalLong"
                  data-backdrop="static"
                  data-keyboard="false"
                  @click="editFillInputs(value), modalPrepareEdit()"
                ></i>
                <i
                  class="fas fa-trash fa-fw deleteBtn"
                  title="წაშლა"
                  data-toggle="modal"
                  data-target="#exampleModalLongDelete"
                  data-backdrop="static"
                  data-keyboard="false"
                  @click="getDeleteId(value.id)"
                ></i>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- <div
      class="modal fade bd-example-modal-lg"
      id="exampleModalLongEdit"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLongTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header green-color">
            <h5 class="modal-title text-white" id="exampleModalLongTitle">ორგანიზაციის რედაქტირება</h5>
            <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <section class="container py-4">
              <div class="row">
                <div class="col-md-12">
                  <ul id="tabsJustifiedEdit" class="nav nav-tabs">
                    <li class="nav-item">
                      <a
                        data-target="#productMenuGroupEdit"
                        data-toggle="tab"
                        class="nav-link small text-uppercase modal-nav active pointer"
                      >ორგანიზაციის მენიუ ჯგუფები</a>
                    </li>
                    <li class="nav-item">
                      <a
                        data-target="#legalBrandEdit"
                        data-toggle="tab"
                        class="nav-link small text-uppercase modal-nav pointer"
                      >ლეგალ ბრენდები</a>
                    </li>
                  </ul>
                  <br>
                  <div id="tabsJustifiedEditContent" class="tab-content">
                    <div
                      id="productMenuGroupEdit"
                      class="tab-pane fade"
                      v-bind:class="{active: isActive, show: isActive}"
                    >
                      <div class="row">
                        <form class="col-12 col-md-6">
                          <div class="form-group">
                            <div class="form-label-group">
                              <input
                                type="text"
                                id="nameGeEdit"
                                class="form-control"
                                placeholder="სახელი ქართულად"
                                autofocus="autofocus"
                                v-model="legalBrandMenuGroup.nameGe"
                                v-on:input="$v.legalBrandMenuGroup.$touch"
                                v-bind:class="{'error-border': $v.legalBrandMenuGroup.nameGe.$error, valid: $v.legalBrandMenuGroup.nameGe.$dirty && !$v.legalBrandMenuGroup.nameGe.$invalid}"
                              >
                              <label for="nameGeEdit">სახელი ქართულად</label>
                            </div>
                            <div class="form-label-group mt-3">
                              <input
                                type="text"
                                id="nameEnEdit"
                                class="form-control"
                                placeholder="English Name"
                                v-model="legalBrandMenuGroup.nameEn"
                                v-on:input="$v.legalBrandMenuGroup.$touch"
                                v-bind:class="{'error-border': $v.legalBrandMenuGroup.nameEn.$error, valid: $v.legalBrandMenuGroup.nameEn.$dirty && !$v.legalBrandMenuGroup.nameEn.$invalid}"
                              >
                              <label for="nameEnEdit">English Name</label>
                            </div>
                            <div class="form-label-group mt-3">
                              <input
                                type="text"
                                id="nameRuEdit"
                                class="form-control"
                                placeholder="имя на русском"
                                v-model="legalBrandMenuGroup.nameRu"
                                v-on:input="$v.legalBrandMenuGroup.$touch"
                                v-bind:class="{'error-border': $v.legalBrandMenuGroup.nameRu.$error, valid: $v.legalBrandMenuGroup.nameRu.$dirty && !$v.legalBrandMenuGroup.nameRu.$invalid}"
                              >
                              <label for="nameRuEdit">имя на русском</label>
                            </div>
                            <div class="form-group form-check mt-3">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                id="showOnlyMainEdit"
                                v-model="legalBrandMenuGroup.showOnlyMain"
                              >
                              <label class="form-check-label" for="showOnlyMainEdit">მხოლოდ მთავარზე ჩვენება</label>
                            </div>
                            <div class="form-group form-check mt-3">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                id="showOnDashboardEdit"
                                v-model="legalBrandMenuGroup.showOnDashboard"
                              >
                              <label class="form-check-label" for="showOnDashboardEdit">Dashboard-ზე ჩვენება</label>
                            </div>
                            <div class="form-group form-check mt-3">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                id="showOnlyDashboardEdit"
                                v-model="legalBrandMenuGroup.showOnlyDashboard"
                              >
                              <label class="form-check-label" for="showOnlyDashboardEdit">მხოლოდ Dashboard-ზე ჩვენება</label>
                            </div>
                          </div>
                        </form>
                        <form class="col-12 col-md-6">
                          <div class="form-group">
                            <div class="form-label-group">
                              <input
                                type="number"
                                id="orderPriorityEdit"
                                class="form-control"
                                placeholder="პრიორიტეტი"
                                v-model="legalBrandMenuGroup.orderPriority"
                                v-on:input="$v.legalBrandMenuGroup.$touch"
                                v-bind:class="{'error-border': $v.legalBrandMenuGroup.orderPriority.$error, valid: $v.legalBrandMenuGroup.orderPriority.$dirty && !$v.legalBrandMenuGroup.orderPriority.$invalid}"
                              >
                              <label for="orderPriorityEdit">პრიორიტეტი</label>
                            </div>
                            <div class="form-label-group">
                              <div class="dropdown mt-3">
                                <button
                                  class="btn btn-info dropdown-toggle"
                                  type="button"
                                  id="dropdownProductCategorySelectEdit"
                                  data-toggle="dropdown"
                                  aria-haspopup="true"
                                  aria-expanded="false"
                                >{{dropDownLegalCategory}}</button>
                                <div class="dropdown-menu" aria-labelledby="dropdownProductCategorySelectEdit">
                                  <a
                                    class="dropdown-item pointer"
                                    v-for="categoryValue in legalCategoriesArray"
                                    :key="categoryValue.id"
                                    v-on:focus="$v.legalBrandMenuGroup.$touch"
                                    @click="dropDownCategoryClick(categoryValue.nameGe, categoryValue.id)"
                                    v-bind:class="{'error-border': $v.legalBrandMenuGroup.lbCategoryId.$error, valid: $v.legalBrandMenuGroup.lbCategoryId.$dirty && !$v.legalBrandMenuGroup.lbCategoryId.$invalid}"
                                  >{{categoryValue.nameGe}}</a>
                                </div>
                              </div>
                            </div>
                            <div class="form-group form-check mt-3">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                id="showOnMainEdit"
                                v-model="legalBrandMenuGroup.showOnMain"
                              >
                              <label class="form-check-label" for="showOnMainEdit">მთავარზე ჩვენება</label>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                    <div id="legalBrandEdit" class="tab-pane fade">
                      <div class="row">
                        <autocomplete
                          :list="legalBrandArray"
                          class="ml-4"
                          optionField="nameGe"
                          :resetField="resetAutocomplete"
                          @input="onAutocompleteInput"
                        >
                          <div slot="list-item" slot-scope="{item}">
                            {{item.nameGe}}
                            <br>
                            {{item.descGe}}
                          </div>
                        </autocomplete>
                      </div>
                      <div class="row">
                        <div v-if="legalBrandMenuGroup.legalBrands.length > 0">
                          <div
                            v-for="legalBrandValue in legalBrandMenuGroup.legalBrands"
                            :key="legalBrandValue.id"
                            class="modal-card card mt-3"
                          >
                            <div class="card-body row">
                              <div class="col-11">
                                სახელი: {{legalBrandValue.nameGe}}
                                <br>
                                აღწერა: {{legalBrandValue.descGe}}
                              </div>
                              <div class="col-1">
                                <i
                                  class="fas fa-times deleteBtn"
                                  title="წაშლა"
                                  @click="removeLegalBrandFormList(legalBrandValue.id)"
                                ></i>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-danger" data-dismiss="modal">დახურვა</button>
            <button
              type="button"
              class="btn btn-success"
              :disabled="!$v.legalBrandMenuGroup.$dirty || $v.legalBrandMenuGroup.$error"
              @click="$v.legalBrandMenuGroup.$touch(), editLegalMenuGroup()"
              data-dismiss="modal"
            >რედაქტირება</button>
          </div>
        </div>
      </div>
    </div> -->
    <div
      class="modal fade bd-example-modal-lg"
      id="exampleModalLongDelete"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLongTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header green-color">
            <h5 class="modal-title text-white" id="exampleModalLongTitle">
              ორგანიზაციის წაშლა
            </h5>
            <button
              type="button"
              class="close text-white"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">გსურთ წაშლა?</div>
          <div class="modal-footer">
            <button type="button" class="btn btn-danger" data-dismiss="modal">
              დახურვა
            </button>
            <button
              type="button"
              class="btn btn-success"
              @click="deleteLegalMenuGroup()"
              data-dismiss="modal"
            >
              წაშლა
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import "../../assets/js/sb-admin.min.js";
import "../../assets/vendor/datatables/jquery.dataTables.js";
import "../../assets/vendor/datatables/dataTables.bootstrap4.js";
import "../../assets/js/demo/datatables-demo.js";
import { bus } from "../common/bus";
import ProductMenuGroupTemplate from "../common/ProductMenuGroupTemplate.vue";
import { required } from "vuelidate/lib/validators";

export default {
  name: "legalBrandMenuGroup",
  components: { autocomplete: ProductMenuGroupTemplate },
  data() {
    return {
      showModal: false,
      legalBrandMenuGroup: {
        id: "",
        nameGe: "",
        nameEn: "",
        nameRu: "",
        orderPriority: null,
        lbCategoryId: null,
        showOnDashboard: false,
        showOnMain: false,
        showOnlyDashboard: false,
        showOnlyMain: false,
        legalBrands: [],
      },
      legalCategory: {
        id: null,
        nameGe: "",
        nameEn: "",
        nameRu: "",
        iconSrc: null,
        legalBRands: [],
      },
      legalBrand: {
        id: null,
        logo: null,
        nameGe: "",
        nameEn: "",
        nameRu: "",
        descGe: "",
        descEn: "",
        descRu: "",
        lBCategoryId: null,
        merchants: [],
      },
      isActive: false,
      isActiveModalPrepare: false,
      resetAutocomplete: false,
      dropDownLegalCategory: "აირჩიეთ კატეგორია",
      legalCategoriesArray: [],
      legalBrandMenuGroupsArray: [],
      legalBrandArray: [],
      legalBrandAutocompleteArray: [],
    };
  },
  validations: {
    legalBrandMenuGroup: {
      nameGe: {
        required,
      },
      nameEn: {
        required,
      },
      nameRu: {
        required,
      },
      orderPriority: {
        required,
      },
      lbCategoryId: {
        required,
      },
      legalBrands: {
        required,
      },
    },
  },
  async created() {
    let legalMenuGroupResult = await this.$http.getLegalBrandMenuGroup();
    this.legalBrandMenuGroupsArray = legalMenuGroupResult.data.res;

    let legalCategoriesResult = await this.$http.getLegalBrandCategories();
    this.legalCategoriesArray = legalCategoriesResult.data.res;

    let legalBrandResult = await this.$http.getLegalBrand();
    this.legalBrandArray = legalBrandResult.data.res;
  },
  methods: {
    async addLegalMenuGroup() {
      try {
        let newLegalBrandArray = [];
        for (let i = 0; i < this.legalBrandMenuGroup.legalBrands.length; i++) {
          newLegalBrandArray[i] = this.legalBrandMenuGroup.legalBrands[i].id;
        }
        let legalMenuGroupObjectAdd = {
          nameGe: this.legalBrandMenuGroup.nameGe,
          nameEn: this.legalBrandMenuGroup.nameEn,
          nameRu: this.legalBrandMenuGroup.nameRu,
          orderPriority: this.legalBrandMenuGroup.orderPriority,
          lbCategoryId: this.legalBrandMenuGroup.lbCategoryId,
          showOnDashboard:
            this.legalBrandMenuGroup.showOnDashboard === null
              ? false
              : this.legalBrandMenuGroup.showOnDashboard,
          showOnlyDashboard:
            this.legalBrandMenuGroup.showOnlyDashboard === null
              ? false
              : this.legalBrandMenuGroup.showOnlyDashboard,
          showOnlyMain:
            this.legalBrandMenuGroup.showOnlyMain === null
              ? false
              : this.legalBrandMenuGroup.showOnlyMain,
          showOnMain:
            this.legalBrandMenuGroup.showOnMain === null
              ? false
              : this.legalBrandMenuGroup.showOnMain,
          lbIds: newLegalBrandArray,
        };

        let legalMenuGroupAddResult = await this.$http.postLegalBrandMenuGroup(
          legalMenuGroupObjectAdd
        );

        if (legalMenuGroupAddResult.data.resultCode === "200") {
          bus.$emit("success", "ორგანიზაციის მენიუ გრუპი წარმატებით დაემატა");
          let legalMenuGroupResult = await this.$http.getLegalBrandMenuGroup();
          this.legalBrandMenuGroupsArray = legalMenuGroupResult.data.res;
        } else {
          bus.$emit(
            "warning",
            "ორგანიზაციის მენიუ გრუპის დამატების დროს მოხდა შეცდომა"
          );
        }
      } catch (error) {
        bus.$emit("error", error);
      }
    },
    async editLegalMenuGroup() {
      try {
        let newLegalBrandArray = [];
        for (let i = 0; i < this.legalBrandMenuGroup.legalBrands.length; i++) {
          newLegalBrandArray[i] = this.legalBrandMenuGroup.legalBrands[i].id;
        }
        let legalMenuGroupObjectEdit = {
          id: this.legalBrandMenuGroup.id,
          nameGe: this.legalBrandMenuGroup.nameGe,
          nameEn: this.legalBrandMenuGroup.nameEn,
          nameRu: this.legalBrandMenuGroup.nameRu,
          orderPriority: this.legalBrandMenuGroup.orderPriority,
          lbCategoryId: this.legalBrandMenuGroup.lbCategoryId,
          showOnDashboard:
            this.legalBrandMenuGroup.showOnDashboard === null
              ? false
              : this.legalBrandMenuGroup.showOnDashboard,
          showOnlyDashboard:
            this.legalBrandMenuGroup.showOnlyDashboard === null
              ? false
              : this.legalBrandMenuGroup.showOnlyDashboard,
          showOnlyMain:
            this.legalBrandMenuGroup.showOnlyMain === null
              ? false
              : this.legalBrandMenuGroup.showOnlyMain,
          showOnMain:
            this.legalBrandMenuGroup.showOnMain === null
              ? false
              : this.legalBrandMenuGroup.showOnMain,
          lbIds: newLegalBrandArray,
        };

        let legalMenuGroupEditResult = await this.$http.putLegalBrandMenuGroup(
          legalMenuGroupObjectEdit
        );

        if (legalMenuGroupEditResult.data.resultCode === "200") {
          bus.$emit(
            "success",
            "ორგანიზაციის მენიუ გრუპი წარმატებით დარედაქტირდა"
          );
          let legalMenuGroupResult = await this.$http.getLegalBrandMenuGroup();
          this.legalBrandMenuGroupsArray = legalMenuGroupResult.data.res;
        } else {
          bus.$emit(
            "warning",
            "ორგანიზაციის მენიუ გრუპის რედაქტირების დროს მოხდა შეცდომა"
          );
        }
      } catch (error) {
        bus.$emit("error", error);
      }
    },
    async deleteLegalMenuGroup() {
      try {
        let legalMenuGroupDeleteResult =
          await this.$http.deleteLegalBrandMenuGroup(
            this.legalBrandMenuGroup.id
          );

        if (legalMenuGroupDeleteResult.data.resultCode === "200") {
          bus.$emit("success", "ორგანიზაციის მენიუ გრუპი წარმატებით წაიშალა");
          let legalMenuGroupResult = await this.$http.getLegalBrandMenuGroup();
          this.legalBrandMenuGroupsArray = legalMenuGroupResult.data.res;
        } else {
          bus.$emit(
            "warning",
            "ორგანიზაციის მენიუ გრუპის წაშლის დროს მოხდა შეცდომა"
          );
        }
      } catch (error) {
        bus.$emit("error", error);
      }
    },
    async editFillInputs(row) {
      this.modalPrepare();
      // this.legalBrandMenuGroup = Object.assign({}, row)\
      let legalBrancMenuGroupResult =
        await this.$http.getByIDLegalBrandMenuGroup(row.id);
      this.legalBrandMenuGroup = legalBrancMenuGroupResult.data.res;
      this.dropDownLegalCategory = this.getLegalCategoryName(row.lbCategoryId);
    },
    getDeleteId(id) {
      this.legalBrandMenuGroup.id = id;
    },
    removeLegalBrandFormList(legalBrandId) {
      let legalBrandIndex = this.legalBrandMenuGroup.legalBrands.findIndex(
        (d) => d.id === legalBrandId
      );
      this.legalBrandMenuGroup.legalBrands.splice(legalBrandIndex, 1);
      let selectedLegalBrandIndex = this.selectedLegalBrandArray.findIndex(
        (d) => d.id === legalBrandId
      );
      this.selectedLegalBrandArray.splice(selectedLegalBrandIndex, 1);
    },
    getLegalCategoryName(id) {
      let legalCategoryIndex = this.legalCategoriesArray.findIndex(
        (d) => d.id === id
      );
      if (legalCategoryIndex !== -1) {
        return this.legalCategoriesArray[legalCategoryIndex].nameGe;
      }
    },
    async dropDownCategoryClick(categoryName, categoryId) {
      this.dropDownLegalCategory = categoryName;
      this.legalCategory.nameGe = categoryName;
      this.legalCategory.id = categoryId;
      this.legalBrandMenuGroup.lbCategoryId = categoryId;
    },
    onAutocompleteInput(object) {
      this.legalBrandMenuGroup.legalBrands.push(object);
      this.resetAutocomplete = !this.resetAutocomplete;
    },
    modalPrepareEdit() {
      this.isActiveModalPrepare = true;
    },
    modalPrepare() {
      this.isActiveModalPrepare = false;
      this.isActive = true;
    },
    clearData() {
      this.legalBrandMenuGroup.id = null;
      this.legalBrandMenuGroup.nameGe = "";
      this.legalBrandMenuGroup.nameEn = "";
      this.legalBrandMenuGroup.nameRu = "";
      this.legalBrandMenuGroup.orderPriority = null;
      this.legalBrandMenuGroup.lbCategoryId = null;
      this.legalBrandMenuGroup.showOnDashboard = false;
      this.legalBrandMenuGroup.showOnMain = false;
      this.legalBrandMenuGroup.showOnlyDashboard = false;
      this.legalBrandMenuGroup.showOnlyMain = false;
      this.legalBrandMenuGroup.legalBrands = [];
      this.legalCategory.id = null;
      this.legalCategory.nameGe = "";
      this.legalCategory.nameEn = "";
      this.legalCategory.nameRu = "";
      this.legalCategory.iconSrc = null;
      this.legalCategory.legalBRands = [];
      this.legalBrand.id = null;
      this.legalBrand.logo = null;
      this.legalBrand.nameGe = "";
      this.legalBrand.nameEn = "";
      this.legalBrand.nameRu = "";
      this.legalBrand.descGe = "";
      this.legalBrand.descEn = "";
      this.legalBrand.descRu = "";
      this.legalBrand.lBCategoryId = null;
      this.legalBrand.merchants = [];
      this.dropDownLegalCategory = "აირჩიეთ კატეგორია";
      this.legalBrandAutocompleteArray = [];
      this.selectedLegalBrandArray = [];
      this.resetAutocomplete = !this.resetAutocomplete;
    },
  },
};
</script>
<style scoped lang="scss">
@import "../../assets/scss/_variables.scss";
@import "../../assets/scss/_mixins.scss";
@import "../../assets/scss/_navbar.scss";
@import "../../assets/scss/sb-admin.scss";
@import "../../assets/css/sb-admin.css";
@import "../../assets/vendor/datatables/dataTables.bootstrap4.css";
@import "../../assets/scss/_login.scss";
@import "../../assets/scss/_global.scss";

// .error-border {
//   border-color: #ffb3b3;
//   box-shadow: none;
// }

// .modal-nav-button {
//   margin-left: 15px;
// }

// .modal-nav {
//   color: #52af8e;
// }

// .editBtn {
//   margin-left: 10px;
//   font-size: 30px;
//   cursor: pointer;
//   color: #52af8e;
// }
// .deleteBtn {
//   font-size: 30px;
//   cursor: pointer;
//   color: #d43f3a;
//   margin-left: 10px;
// }

// .searchBtn {
//   font-size: 40px;
//   margin-top: -5px;
//   cursor: pointer;
//   color: #489d7f;
// }

// .addNewBtn {
//   font-size: 44px;
//   margin-left: 15px;
//   cursor: pointer;
//   color: #52af8e;
//   margin-top: -5px;
// }

// .pointer {
//   cursor: pointer;
// }

// .modal-card {
//   background-color: #eef7f4;
// }

// @media only screen and (min-width: 1450px) {
//   #no-more-tables table {
//     border-style: none;
//   }
//   #no-more-tables th {
//     padding: 12px;
//     font-weight: bold;
//     border-style: none;
//     border-bottom: solid #212529 4px;
//   }
//   #no-more-tables td {
//     padding: 10px;
//     font-family: "BPGNinoMtavruli";
//     border-style: none;
//     border-bottom: solid #212529 2px;
//   }
// }

// @media only screen and (max-width: 1450px) {
//   .deleteBtn {
//     margin-left: 5px;
//   }
//   #no-more-tables table,
//   #no-more-tables thead,
//   #no-more-tables tbody,
//   #no-more-tables th,
//   #no-more-tables td,
//   #no-more-tables tr {
//     display: block;
//     border-style: none;
//   }
//   #no-more-tables thead tr {
//     position: absolute;
//     top: -9999px;
//     left: -9999px;
//   }
//   #no-more-tables tr {
//     border-bottom: 4px solid #212529;
//   }
//   #no-more-tables td {
//     border-bottom: 1px solid #eee;
//     position: relative;
//     padding-left: 50%;
//     white-space: normal;
//     text-align: left;
//   }
//   #no-more-tables td:before {
//     position: absolute;
//     top: 6px;
//     left: 6px;
//     width: 45%;
//     padding-right: 10px;
//     white-space: nowrap;
//     text-align: left;
//     font-weight: bold;
//   }
//   #no-more-tables td:before {
//     content: attr(data-title);
//   }
// }
// @media only screen and (max-width: 600px) {
//   .container {
//     padding-left: 0px;
//     padding-right: 0px;
//   }
//   #no-more-tables table {
//     padding-left: 0px;
//     padding-right: 0px;
//   }
// }
</style>



// WEBPACK FOOTER //
// src/components/view/LegalBrandMenuGroup.vue